import {
    Container,
    Paper,
    Typography,
    Box,
    Button
} from "@mui/material";

import FileUpload from "./FileUpload";
import styles from "../../styles/backButton.module.scss";
import btnStyles from '../../styles/buttons.module.scss';


export default function DocumentsForm({

    data,

    errors,

    handleDocumentUpload,

    onBack,

    onContinue

}) {

     return (

            <Paper
                elevation={3}
                sx={{
                    maxWidth: 1200,
                    mx: "auto",
                    mt: 4,
                    mb: 4,
                    px: { xs: 2, md: 4 },
                    py: 3,
                    borderRadius: 2
                }}
            >

                <Typography
                    variant="h4"
                    gutterBottom
                >

                    Supporting Documents

                </Typography>

                <Typography
                    sx={{
                        mb: 4, color: "rgba(0,0,0,0.6)",
                    }}
                >

                    Upload your CV below.

                </Typography>

                <FileUpload

                    label="Upload your CV (PDF)"

                    file={data.cv}

                    error={errors.cv}

                    acceptedTypes={[

                        "application/pdf"

                    ]}

                    onChange={(file) =>

                        handleDocumentUpload(

                            "cv",

                            file

                        )

                    }

                />

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 5
                    }}
                >

                    <Button
                        variant="contained"
                        onClick={onBack}
                        className={styles.backSingleBtn}
                        sx={{  mt: "20px", mb: "20px"}}
                    >
                        Back
                    </Button>

                    <Button
                        className={btnStyles.btnDesktop}
                        variant="contained"
                        size="large"
                        sx={{ textTransform: 'none' }}
                        onClick={onContinue}
                    >

                        Continue

                    </Button>

                </Box>

            </Paper>

    );

}